var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8053 3.37658C19.3074 2.87447 20.1213 2.87447 20.6234 3.37658C21.1255 3.87869 21.1255 4.69257 20.6234 5.19468L13.8181 12L20.6234 18.8053L20.7113 18.9033C21.1232 19.4083 21.0941 20.1527 20.6234 20.6234C20.1527 21.0941 19.4083 21.1232 18.9033 20.7113L18.8053 20.6234L12 13.8181L5.19468 20.6234C4.69257 21.1255 3.87869 21.1255 3.37658 20.6234C2.87447 20.1213 2.87447 19.3074 3.37658 18.8053L10.1819 12L3.37658 5.19468C2.87447 4.69257 2.87447 3.87869 3.37658 3.37658C3.87869 2.87447 4.69257 2.87447 5.19468 3.37658L12 10.1819L18.8053 3.37658Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.dbae673a5eb4976f76343d56afa20e82.svg";
export { ForwardRef as ReactComponent };